export default __webpack_public_path__ + "static/Plots0026-365e42e649aca931359a43de94be2cd5.jpg";